<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1722Oc9/tc-custom/9781681880044.jpg?1700306302650" alt="This image is the cover for the book Total Flyfishing Manual, Field & Stream"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Total Flyfishing Manual, Field & Stream
      </h1>
      <p class="bookDescription body article font2">
        <b>The most comprehensive fly fishing guide with the best tips, old school-techniques, tactics, and up-to-date gear reviews.</b><br/><br/>Filled with over three hundred hints from the best anglers in both salt and fresh water, the editors of <i>Field and Stream</i> give you everything you need to make the perfect pitch, find a secret spot, and score a fish.<br/><br/>TOOLS: From the best flies of all time to the best reel for the job and when to change your hooks, learn about the tools you need for the job—as well as practical skills like tying a Palomar knot, how to unravel fly lines, the five-minute fly, tying a clouser minnow, and how to lose the tailing loop.<br/><br/>TECHNIQUES: From old to new, everything you need to know to strike in the night, put a different spin on it, spot and stalk, shoot the breeze, and find where they feed.<br/><br/>TACTICS: Put yourself in the best position for the catch: get up the creek for a late-season trout, find a secret spot, sneak up on more fish, fish headwaters for autumn trout, fish with your eyes, hook more rising fish, take the long shot, and dominate the shoreline.<br/><br/>Whether you’re fishing for salmon, bass, or carp, this guide will help you improve your technique, upgrade your equipment, and hook your prize fish.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joe Cermele, The Editors of Field & Stream
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Weldonowen
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2bb24dce